<p>
  manage-fine-name works!
</p>
